(() => {
  window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.ce_carousel_heroslider').forEach((slider) => {
      let sliderCarousel = new BSN.Carousel(slider, {
        'interval': 8000,
        'keyboard': true,
        'pause': 'hover',
        'ride': 'carousel',
        'wrap': true
      });

      slider.querySelectorAll('a[data-slide="prev"]').forEach((prevButton) => {
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          sliderCarousel.slideTo(sliderCarousel.getActiveIndex() - 1)
        })
      })

      slider.querySelectorAll('a[data-slide="next"]').forEach((nextButton) => {
        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          sliderCarousel.slideTo(sliderCarousel.getActiveIndex() + 1)
        })
      })
    })
  })
}) ()